import { router } from "@inertiajs/react"

import { Button } from "@/components/ui/button"

// IMP-197: shown on the agent dashboard while a cancellation is scheduled. The
// agent stays active until `deactivatesOn`; Undo clears the schedule.
export function CancellationBanner({
  agentUid,
  deactivatesOn,
}: {
  agentUid: string
  deactivatesOn: string
}) {
  // Format from the YYYY-MM-DD parts to avoid a UTC-parse off-by-one.
  const [y, m, d] = deactivatesOn.split("-").map(Number)
  const label = new Date(y, m - 1, d).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  })

  return (
    <div className="flex flex-col gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-sm text-amber-900">
        This agent was canceled and will deactivate on{" "}
        <span className="font-medium">{label}</span>.
      </p>
      <Button
        size="sm"
        variant="outline"
        className="shrink-0 border-amber-300 bg-white hover:bg-amber-100"
        onClick={() => router.post(`/agents/${agentUid}/undo_cancellation`)}
      >
        Undo cancellation
      </Button>
    </div>
  )
}
